module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-02-c9188bf32c288fdcb3dd3c2e5523559e.jpg";